import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Constants } from "src/Constants";
import { DeleteUser, FetchAllUsers } from "src/Thunk/adminThunks";
import { clearMsg } from "src/Actions/Admin/adminActions";
const MySwal = withReactContent(Swal);

const UserList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  let itemsPerPage = 10;

  const [deleteSuccess, setDeleteSuccess] = useState(true);
  const { usersList,msg,error} = useSelector((state) => state.admin);

  useEffect(() => {
    if (deleteSuccess) {
      dispatch(FetchAllUsers());
    }
  }, [deleteSuccess]);

  const filteredSpecialities = usersList.filter((customer) =>
    Object.values(customer).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSpecialities?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  useEffect(() => {
    if (msg) {
      MySwal.fire({
        icon: "success",
        title: msg,
      });
      setDeleteSuccess(false);
      setTimeout(() => {
        setDeleteSuccess(true);
      }, 1000);
    }
    if (error) {
      MySwal.fire({
        icon: "error",
        title: error,
      });
    }
  }, [msg, error]);

  const handleDeleteUser = async (id) => {
    dispatch(DeleteUser(id));
  };


  return (
    <div className="main-content">
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 text-info">USERS List</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">Home</Link>
                    </li>
                    <li className="breadcrumb-item text-info active">
                      Users List
                    </li>
                  </ol>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="card custom-shadow rounded-lg border my-3">
                <div className="card-body">
                  <Row>
                    <Col md={4} xs={12} className="mb-3 text-center">
                      <h3 className="fw-bolder text-info mb-0">
                        {usersList.length || 0}
                      </h3>
                      <p className="text-secondary">Total Users</p>
                    </Col>
                  </Row>

                  <div className="dataTables_length mb-2">
                    <label>
                      <Link
                        className="btn btn-sm btn-primary text-white"
                        to={`/AddNewUser`}
                      >
                        <FontAwesomeIcon icon={faPlus} /> Add New
                      </Link>
                    </label>
                    <div className="search-box">
                      <input
                        type="text"
                        id="search"
                        placeholder="Search "
                        name="search"
                        className="form-control "
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="table-responsive">
                    <Table responsive bordered22 hover>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>UserType</th>
                          <th>Email</th>
                          <th>Gender</th>
                          <th>ProfilePic</th>
                          <th>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems?.map((user, index) => (
                          <tr key={index}>
                            <td>{user?.Name}</td>
                            <td>{user.userType}</td>
                            <td>{user.email}</td>
                            <td>{user.gender}</td>
                           
                              <td>
                              {user.profilePic && (
                              <img
                                src={`${Constants.getImg}${user.profilePic}`}
                                width={50}
                                height={50}
                              />)}
                            </td>
                            
                            <td>
                              <div className="icon-container">
                                <Button
                                  variant="danger"
                                  size="sm"
                                  title="Delete User"
                                  onClick={() => {
                                    MySwal.fire({
                                      title: "Are you sure?",
                                      text: "Once deleted, you will not be able to recover this data!",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonText: "Yes, delete it!",
                                      cancelButtonText: "No, cancel!",
                                      reverseButtons: true,
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        handleDeleteUser(user._id)
                                      }
                                    });
                                  }}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <Container>
                    <div className="col-sm-12 col-md-5">
                      <div className="dataTables_length">
                        Showing {indexOfFirstItem + 1} to{" "}
                        {Math.min(indexOfLastItem, usersList.length || 0)} of{" "}
                        {usersList.length || 0} entries
                      </div>
                    </div>
                    <div>
                      {Array.from({
                        length: Math.ceil(usersList.length / itemsPerPage),
                      }).map((_, index) => (
                        <button
                          key={index}
                          type="button"
                          className="btn btn-primary btn-circle btn-sm text-white m-1"
                          onClick={() => paginate(index + 1)}
                        >
                          {index + 1}
                        </button>
                      ))}
                    </div>
                  </Container>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default UserList;
